module.exports = __webpack_public_path__ + "static/media/car4.bf910760.webp";